import React from "react";

import { useBreakpoint } from "../../hooks/useBreakpoint";
import { Link } from "../../utils/customLink";

import Image from "../../components/image";

import URLogo from "../../images/virtual-internship/richmond-logo.png";
import TickIcon from "../../images/virtual-internship/tick-icon.svg";
import ExtrasIcon from "../../images/virtual-internship/extras-icon.inline.svg";
import ExtrasIconLight from "../../images/virtual-internship/extras-icon-light.inline.svg";

const VICurriculum = ({
  curriculumTitle,
  curriculumDesc,
  curriculumExtras,
  curriculumList,
  curriculumImageDesktop,
  curriculumImageMobile,
  applyLink
}) => {
  const breakpoint = useBreakpoint();
  return (
    <>
      <div className="py-16 md:py-36 relative">
        <Image
          image={""}
          imageAlt={""}
          imageClass={
            "absolute top-0 left-0 sm:bottom-0 right-0 z-0 w-full sm:h-full object-cover object-center"
          }
          sourceUrl={
            breakpoint && breakpoint === "xs"
              ? curriculumImageMobile
              : curriculumImageDesktop
          }
        />
        <div className="relative mt-56 sm:mt-0 z-10 gvi-container mx-auto tab-content">
          <div
            className="flex mx-auto h1 pb-7 !font-light"
            dangerouslySetInnerHTML={{
              __html: curriculumTitle
            }}
          />
          {curriculumDesc && (
            <div
              className="w-full md:w-1/2 py-4 text-base leading-normal text-black-lighter dark:text-gray-darken"
              dangerouslySetInnerHTML={{ __html: curriculumDesc }}
            />
          )}
          <div className="flex space-between w-full md:w-3/4 flex-col md:flex-row py-4 text-base leading-normal text-gray-darken">
            <div className="w-full md:w-1/3 h-32 md:h-auto p-4 rounded-xs flex items-center relative bg-generic-text dark:bg-generic-bg">
              <Image
                image={URLogo}
                imageAlt={""}
                imageClass={"md:w-full w-11/12 object-center h-auto"}
                sourceUrl={""}
              />
            </div>
            <div className="flex flex-col md:flex-row space-between w-full">
              {curriculumList?.map((course, index) => (
                <div
                  className={`flex flex-col space-between w-full mt-3 md:mt-0 md:ml-2 p-4 rounded-xs ${
                    index === 1 ? "md:w-2/3" : "md:w-1/3"
                  } bg-generic-text dark:bg-generic-bg`}
                  key={`mb-course-${index}`}
                >
                  <div className="flex items-center justify-between py-2">
                    <Image
                      image={TickIcon}
                      imageAlt={""}
                      imageClass={
                        "w-30 object-center object-cover p-0 md:-ml-4 m-0 leading-0"
                      }
                      sourceUrl={""}
                    />
                    <div
                      className="w-full mb-2 text-xl leading-normal text-white font-semibold"
                      dangerouslySetInnerHTML={{
                        __html: course?.viCourseTitle ?? ""
                      }}
                    />
                  </div>
                  <div
                    className="w-full py-4 text-base leading-normal text-white dark:text-gray-generic"
                    dangerouslySetInnerHTML={{
                      __html: course?.viCourseDescription ?? ""
                    }}
                  />
                </div>
              ))}
            </div>
          </div>

          <div className="w-full flex py-7">
            <ExtrasIcon className="hidden dark:block  dark:fill-white" />
            <ExtrasIconLight className="dark:hidden block fill-black-lighter" />
            <div
              className="text-base font-bold text-generic-text dark:text-white pl-2"
              dangerouslySetInnerHTML={{
                __html: curriculumExtras
              }}
            />
          </div>
          <Link
            className="submit-button group flex md:inline-flex justify-center items-center px-20 py-2 mt-8"
            to={applyLink}
          >
            <p className="pr-2 font-bold">Apply</p>
          </Link>
        </div>
      </div>
    </>
  );
};

export default VICurriculum;
